export const environment = {
    production: true,
    spouse_cookies:"_sc_",
    fbpCookies:"_fbp",
    cookie_term_visitId: 'Cookie_Term_VisitLog',
    termClaim:"https://termclaim.policybazaar.com",
    termClaimApi: "https://termclaim.policybazaar.com/",
    enquiryExpiryDays: 90
    // termClaim:"https://termcjapi.policybazaar.com/pbclaim/"
  };